import {useDropzone} from 'react-dropzone';
import SvgFiles from 'components/ui/Icon/svg/Files';
import {fileUploadStore} from 'components/ui/FileUpload/fileUploadStore';
import UploadedFile, {
    FileManagement,
} from 'components/ui/FileUpload/components/UploadedFile';
import classNames from 'classnames';
import styles from './FileUpload.module.scss';
import {
    ICardTransactionDetail,
    ICardTransactionDetailsPublic,
    Transaction,
} from 'types/transactions';

interface IProps {
    handleFileUpload: (file: File) => void;
    baseUrl: string;
    fileManagementMethods: FileManagement;
    transactionOrDetail?:
        | ICardTransactionDetail
        | ICardTransactionDetailsPublic
        | Transaction;
    maxFiles?: number;
    dragInstructionText?: string;
}

const FileUpload = ({
    handleFileUpload,
    baseUrl,
    fileManagementMethods,
    transactionOrDetail,
    maxFiles,
    dragInstructionText = 'Drag file(s) here',
}: IProps) => {
    const files = fileUploadStore(state => state.files);

    const isDisabled = !!transactionOrDetail?.expenseCompletedAt;

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        accept: {
            'application/pdf': ['.pdf'],
            'image/*': ['.png', '.jpg', '.jpeg', '.tiff'],
        },
        onDrop: async acceptedFiles => {
            acceptedFiles.forEach(handleFileUpload);
        },
        disabled: isDisabled,
        maxFiles,
    });

    return (
        <div className={styles.container}>
            <div
                {...getRootProps({
                    className: classNames(styles.dropZone, {
                        [styles.isDragActive]: isDragActive,
                        [styles.disabled]: isDisabled,
                    }),
                })}
            >
                <input {...getInputProps()} />
                <SvgFiles width="120px" />
                <p className={styles.title} data-isolate>
                    {dragInstructionText} or&nbsp;
                    <span className={styles.fakeLink}>click to upload</span>
                </p>
                <p className={styles.helper} data-isolate>
                    Only JPG, JPEG, TIFF, PNG and PDF formats.
                    <br />
                    Max file size 8 MB.
                </p>
            </div>
            {Object.keys(files)
                .reverse()
                .map(uuid => (
                    <UploadedFile
                        key={uuid}
                        fileState={files[uuid]}
                        baseUrl={baseUrl}
                        fileManagementMethods={fileManagementMethods}
                        uuid={uuid}
                        disabled={isDisabled}
                    />
                ))}
        </div>
    );
};

export default FileUpload;
